import React, { useEffect, useState } from 'react';

/**
 * "Couldn't load the list of HMS companies" — once, on whatever screen is open.
 *
 * Row 128: `services/hmsEntityService.fetchHMSEntities` returns [] when the
 * server fails and dispatches `hms-entities-load-failed`. Twelve screens build
 * company pickers from it (deliveries, recaps, deals, contracts, invoices, bank
 * reconciliation) and read the empty list as "no companies". Nothing listened,
 * so the failure was invisible. Layout mounts this once, so every one of those
 * screens says the list failed instead of looking empty. A successful load
 * (`hms-entities-loaded`) clears it.
 */
const CompanyListFailedBanner = () => {
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        const onFailed = () => setFailed(true);
        const onLoaded = () => setFailed(false);
        window.addEventListener('hms-entities-load-failed', onFailed);
        window.addEventListener('hms-entities-loaded', onLoaded);
        return () => {
            window.removeEventListener('hms-entities-load-failed', onFailed);
            window.removeEventListener('hms-entities-loaded', onLoaded);
        };
    }, []);

    if (!failed) return null;
    return (
        <div
            role="alert"
            data-testid="company-list-failed"
            style={{
                margin: '12px 16px 0',
                padding: '10px 14px',
                borderRadius: 8,
                background: '#fef2f2',
                border: '1px solid #fecaca',
                color: '#991b1b',
                fontSize: '0.9rem',
            }}
        >
            Couldn&apos;t load the list of IMT companies, so company pickers on this page are empty.
            Save any work, then reload the page to try again.
        </div>
    );
};

export default CompanyListFailedBanner;
